const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class FulfilmentSelectorSelectedAddressController {
    constructor(settings, addressService, analyticsService, fulfilmentSelectorService, fulfilmentService) {
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.fulfilmentService = fulfilmentService;
    }

    $onInit() {
        this.fulfilmentSelectorService.setModalTitleMessage('');
        const existingfulfilmentMethodType = this.fulfilmentService.selectedFulfilmentMethod.type;
        this.selectedFulfilmentMethod = this.fulfilmentSelectorService.getSelectorFulfilmentOption(existingfulfilmentMethodType);
        this.addressToDisplay = this.fulfilmentSelectorService.getAddressToDisplay(existingfulfilmentMethodType, this.fulfilmentService.savedAddress);

        this.screenName = 'Confirmation';
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withEventType('fulfilmentSelectorDialog')
            .build();
        this.analyticsService.push(event);

        this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
    }

    onChangeAddress() {
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Button/link click')
            .withValue('Change')
            .withEventName('modal_interaction')
            .withEventType('fulfilmentSelectorDialog')
            .build();
        this.analyticsService.push(event);

        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.confirm;
    }

    onStartShopping() {
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Button/link click')
            .withValue('Confirm')
            .withEventName('modal_interaction')
            .withEventType('fulfilmentSelectorDialog')
            .build();
        this.analyticsService.push(event);
    }

    $onDestroy() {
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }
}

FulfilmentSelectorSelectedAddressController.$inject = ['Settings', 'AddressService', 'AnalyticsService', 'FulfilmentSelectorService', 'FulfilmentService'];

const fulfilmentSelectorSelectedAddressComponentDefinition = {
    controller: FulfilmentSelectorSelectedAddressController,
    template: require('./fulfilment-selector-selected-address.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorSelectedAddressController,
    fulfilmentSelectorSelectedAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-selected-address.component.js